import { render, staticRenderFns } from "./questionManage.vue?vue&type=template&id=64251d60&scoped=true"
import script from "./questionManage.vue?vue&type=script&lang=js"
export * from "./questionManage.vue?vue&type=script&lang=js"
import style0 from "./questionManage.vue?vue&type=style&index=0&id=64251d60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64251d60",
  null
  
)

export default component.exports